import React from 'react'
import './ExploreContainer.css'

interface ContainerProps {
  name: string
}

function ExploreContainer({name}: ContainerProps): JSX.Element {
  return (
    <div className="container">
      <strong>{name}</strong>
      <p>
        Explore{' '}
        <a
          target="_self"
          rel="noopener noreferrer"
          href="https://ionicframework.com/docs/components"
        >
          UI Components
        </a>
      </p>
    </div>
  )
}

export default ExploreContainer
